module.exports = (() => {

    const countryData = [
        {name: 'Afghanistan', code2: 'AF', code3: 'AFG', numeric: '004'},
        {name: 'Åland Islands', code2: 'AX', code3: 'ALA', numeric: '248'},
        {name: 'Albania', code2: 'AL', code3: 'ALB', numeric: '008'},
        {name: 'Algeria', code2: 'DZ', code3: 'DZA', numeric: '012'},
        {name: 'American Samoa', code2: 'AS', code3: 'ASM', numeric: '016'},
        {name: 'Andorra', code2: 'AD', code3: 'AND', numeric: '020'},
        {name: 'Angola', code2: 'AO', code3: 'AGO', numeric: '024'},
        {name: 'Anguilla', code2: 'AI', code3: 'AIA', numeric: '660'},
        {name: 'Antarctica', code2: 'AQ', code3: 'ATA', numeric: '010'},
        {name: 'Antigua and Barbuda', code2: 'AG', code3: 'ATG', numeric: '028'},
        {name: 'Argentina', code2: 'AR', code3: 'ARG', numeric: '032'},
        {name: 'Armenia', code2: 'AM', code3: 'ARM', numeric: '051'},
        {name: 'Aruba', code2: 'AW', code3: 'ABW', numeric: '533'},
        {name: 'Australia', code2: 'AU', code3: 'AUS', numeric: '036'},
        {name: 'Austria', code2: 'AT', code3: 'AUT', numeric: '040'},
        {name: 'Azerbaijan', code2: 'AZ', code3: 'AZE', numeric: '031'},
        {name: 'Bahamas', code2: 'BS', code3: 'BHS', numeric: '044'},
        {name: 'Bahrain', code2: 'BH', code3: 'BHR', numeric: '048'},
        {name: 'Bangladesh', code2: 'BD', code3: 'BGD', numeric: '050'},
        {name: 'Barbados', code2: 'BB', code3: 'BRB', numeric: '052'},
        {name: 'Belarus', code2: 'BY', code3: 'BLR', numeric: '112'},
        {name: 'Belgium', code2: 'BE', code3: 'BEL', numeric: '056'},
        {name: 'Belize', code2: 'BZ', code3: 'BLZ', numeric: '084'},
        {name: 'Benin', code2: 'BJ', code3: 'BEN', numeric: '204'},
        {name: 'Bermuda', code2: 'BM', code3: 'BMU', numeric: '060'},
        {name: 'Bhutan', code2: 'BT', code3: 'BTN', numeric: '064'},
        {name: 'Bolivia', code2: 'BO', code3: 'BOL', numeric: '068'},
        {name: 'Bonaire, Sint Eustatius and Saba', code2: 'BQ', code3: 'BES', numeric: '535'},
        {name: 'Bosnia and Herzegovina', code2: 'BA', code3: 'BIH', numeric: '070'},
        {name: 'Botswana', code2: 'BW', code3: 'BWA', numeric: '072'},
        {name: 'Bouvet Island', code2: 'BV', code3: 'BVT', numeric: '074'},
        {name: 'Brazil', code2: 'BR', code3: 'BRA', numeric: '076'},
        {name: 'British Indian Ocean Territory', code2: 'IO', code3: 'IOT', numeric: '086'},
        {name: 'Brunei Darussalam', code2: 'BN', code3: 'BRN', numeric: '096'},
        {name: 'Bulgaria', code2: 'BG', code3: 'BGR', numeric: '100'},
        {name: 'Burkina Faso', code2: 'BF', code3: 'BFA', numeric: '854'},
        {name: 'Burundi', code2: 'BI', code3: 'BDI', numeric: '108'},
        {name: 'Cape Verde', code2: 'CV', code3: 'CPV', numeric: '132'},
        {name: 'Cambodia', code2: 'KH', code3: 'KHM', numeric: '116'},
        {name: 'Cameroon', code2: 'CM', code3: 'CMR', numeric: '120'},
        {name: 'Canada', code2: 'CA', code3: 'CAN', numeric: '124'},
        {name: 'Cayman Islands', code2: 'KY', code3: 'CYM', numeric: '136'},
        {name: 'Central African Republic', code2: 'CF', code3: 'CAF', numeric: '140'},
        {name: 'Chad', code2: 'TD', code3: 'TCD', numeric: '148'},
        {name: 'Chile', code2: 'CL', code3: 'CHL', numeric: '152'},
        {name: 'China', code2: 'CN', code3: 'CHN', numeric: '156'},
        {name: 'Christmas Island', code2: 'CX', code3: 'CXR', numeric: '162'},
        {name: 'Cocos Islands', code2: 'CC', code3: 'CCK', numeric: '166'},
        {name: 'Colombia', code2: 'CO', code3: 'COL', numeric: '170'},
        {name: 'The Comoros', code2: 'KM', code3: 'COM', numeric: '174'},
        {name: 'Congo-Kinshasa', code2: 'CD', code3: 'COD', numeric: '180'},
        {name: 'Congo', code2: 'CG', code3: 'COG', numeric: '178'},
        {name: 'Cook Islands', code2: 'CK', code3: 'COK', numeric: '184'},
        {name: 'Costa Rica', code2: 'CR', code3: 'CRI', numeric: '188'},
        {name: 'Ivory Coast', code2: 'CI', code3: 'CIV', numeric: '384'},
        {name: 'Republic of Ragusa', code2: 'HR', code3: 'HRV', numeric: '191'},
        {name: 'Cuba', code2: 'CU', code3: 'CUB', numeric: '192'},
        {name: 'Curacao', code2: 'CW', code3: 'CUW', numeric: '531'},
        {name: 'Cyprus', code2: 'CY', code3: 'CYP', numeric: '196'},
        {name: 'Czechia', code2: 'CZ', code3: 'CZE', numeric: '203'},
        {name: 'Denmark', code2: 'DK', code3: 'DNK', numeric: '208'},
        {name: 'Djibouti', code2: 'DJ', code3: 'DJI', numeric: '262'},
        {name: 'Dominica', code2: 'DM', code3: 'DMA', numeric: '212'},
        {name: 'Dominican Republic', code2: 'DO', code3: 'DOM', numeric: '214'},
        {name: 'Ecuador', code2: 'EC', code3: 'ECU', numeric: '218'},
        {name: 'Egypt', code2: 'EG', code3: 'EGY', numeric: '818'},
        {name: 'El Salvador', code2: 'SV', code3: 'SLV', numeric: '222'},
        {name: 'Equatorial Guinea', code2: 'GQ', code3: 'GNQ', numeric: '226'},
        {name: 'Eritrea', code2: 'ER', code3: 'ERI', numeric: '232'},
        {name: 'Estonia', code2: 'EE', code3: 'EST', numeric: '233'},
        {name: 'Swaziland', code2: 'SZ', code3: 'SWZ', numeric: '748'},
        {name: 'Ethiopia', code2: 'ET', code3: 'ETH', numeric: '231'},
        {name: 'Falkland Islands', code2: 'FK', code3: 'FLK', numeric: '238'},
        {name: 'The Faroe Islands', code2: 'FO', code3: 'FRO', numeric: '234'},
        {name: 'Fiji', code2: 'FJ', code3: 'FJI', numeric: '242'},
        {name: 'Finland', code2: 'FI', code3: 'FIN', numeric: '246'},
        {name: 'France', code2: 'FR', code3: 'FRA', numeric: '250'},
        {name: 'French Guiana', code2: 'GF', code3: 'GUF', numeric: '254'},
        {name: 'French Polynesia', code2: 'PF', code3: 'PYF', numeric: '258'},
        {name: 'French Southern Territories', code2: 'TF', code3: 'ATF', numeric: '260'},
        {name: 'Gabon', code2: 'GA', code3: 'GAB', numeric: '266'},
        {name: 'Gambia', code2: 'GM', code3: 'GMB', numeric: '270'},
        {name: 'Georgia', code2: 'GE', code3: 'GEO', numeric: '268'},
        {name: 'Germany', code2: 'DE', code3: 'DEU', numeric: '276'},
        {name: 'Ghana', code2: 'GH', code3: 'GHA', numeric: '288'},
        {name: 'Gibraltar', code2: 'GI', code3: 'GIB', numeric: '292'},
        {name: 'Greece', code2: 'GR', code3: 'GRC', numeric: '300'},
        {name: 'Greenland', code2: 'GL', code3: 'GRL', numeric: '304'},
        {name: 'Grenada', code2: 'GD', code3: 'GRD', numeric: '308'},
        {name: 'Guadeloupe', code2: 'GP', code3: 'GLP', numeric: '312'},
        {name: 'Guam', code2: 'GU', code3: 'GUM', numeric: '316'},
        {name: 'Guatemala', code2: 'GT', code3: 'GTM', numeric: '320'},
        {name: 'Guernsey', code2: 'GG', code3: 'GGY', numeric: '831'},
        {name: 'Guinea', code2: 'GN', code3: 'GIN', numeric: '324'},
        {name: 'Guinea-Bissau', code2: 'GW', code3: 'GNB', numeric: '624'},
        {name: 'Guyana', code2: 'GY', code3: 'GUY', numeric: '328'},
        {name: 'Haiti', code2: 'HT', code3: 'HTI', numeric: '332'},
        {name: 'Heard Island and McDonald Islands', code2: 'HM', code3: 'HMD', numeric: '334'},
        {name: 'Vatican City', code2: 'VA', code3: 'VAT', numeric: '336'},
        {name: 'Honduras', code2: 'HN', code3: 'HND', numeric: '340'},
        {name: 'Hong Kong', code2: 'HK', code3: 'HKG', numeric: '344'},
        {name: 'Hungary', code2: 'HU', code3: 'HUN', numeric: '348'},
        {name: 'Iceland', code2: 'IS', code3: 'ISL', numeric: '352'},
        {name: 'India', code2: 'IN', code3: 'IND', numeric: '356'},
        {name: 'Indonesia', code2: 'ID', code3: 'IDN', numeric: '360'},
        {name: 'Iran', code2: 'IR', code3: 'IRN', numeric: '364'},
        {name: 'Iraq', code2: 'IQ', code3: 'IRQ', numeric: '368'},
        {name: 'Ireland', code2: 'IE', code3: 'IRL', numeric: '372'},
        {name: 'Isle of Man', code2: 'IM', code3: 'IMN', numeric: '833'},
        {name: 'Israel', code2: 'IL', code3: 'ISR', numeric: '376'},
        {name: 'Italy', code2: 'IT', code3: 'ITA', numeric: '380'},
        {name: 'Jamaica', code2: 'JM', code3: 'JAM', numeric: '388'},
        {name: 'Japan', code2: 'JP', code3: 'JPN', numeric: '392'},
        {name: 'Jersey', code2: 'JE', code3: 'JEY', numeric: '832'},
        {name: 'Jordan', code2: 'JO', code3: 'JOR', numeric: '400'},
        {name: 'Kazakhstan', code2: 'KZ', code3: 'KAZ', numeric: '398'},
        {name: 'Kenya', code2: 'KE', code3: 'KEN', numeric: '404'},
        {name: 'Kiribati', code2: 'KI', code3: 'KIR', numeric: '296'},
        {name: 'North Korea', code2: 'KP', code3: 'PRK', numeric: '408'},
        {name: 'South Korea', code2: 'KR', code3: 'KOR', numeric: '410'},
        {name: 'Kuwait', code2: 'KW', code3: 'KWT', numeric: '414'},
        {name: 'Kyrgyzstan', code2: 'KG', code3: 'KGZ', numeric: '417'},
        {name: 'Laos', code2: 'LA', code3: 'LAO', numeric: '418'},
        {name: 'Latvia', code2: 'LV', code3: 'LVA', numeric: '428'},
        {name: 'Lebanon', code2: 'LB', code3: 'LBN', numeric: '422'},
        {name: 'Lesotho', code2: 'LS', code3: 'LSO', numeric: '426'},
        {name: 'Liberia', code2: 'LR', code3: 'LBR', numeric: '430'},
        {name: 'Libya', code2: 'LY', code3: 'LBY', numeric: '434'},
        {name: 'Liechtenstein', code2: 'LI', code3: 'LIE', numeric: '438'},
        {name: 'Lithuania', code2: 'LT', code3: 'LTU', numeric: '440'},
        {name: 'Luxembourg', code2: 'LU', code3: 'LUX', numeric: '442'},
        {name: 'Macao', code2: 'MO', code3: 'MAC', numeric: '446'},
        {name: 'Madagascar', code2: 'MG', code3: 'MDG', numeric: '450'},
        {name: 'Malawi', code2: 'MW', code3: 'MWI', numeric: '454'},
        {name: 'Malaysia', code2: 'MY', code3: 'MYS', numeric: '458'},
        {name: 'Maldives', code2: 'MV', code3: 'MDV', numeric: '462'},
        {name: 'Mali', code2: 'ML', code3: 'MLI', numeric: '466'},
        {name: 'Malta', code2: 'MT', code3: 'MLT', numeric: '470'},
        {name: 'The Marshall Islands', code2: 'MH', code3: 'MHL', numeric: '584'},
        {name: 'Martinique', code2: 'MQ', code3: 'MTQ', numeric: '474'},
        {name: 'Mauritania', code2: 'MR', code3: 'MRT', numeric: '478'},
        {name: 'Mauritius', code2: 'MU', code3: 'MUS', numeric: '480'},
        {name: 'Mayotte', code2: 'YT', code3: 'MYT', numeric: '175'},
        {name: 'Mexico', code2: 'MX', code3: 'MEX', numeric: '484'},
        {name: 'Micronesia', code2: 'FM', code3: 'FSM', numeric: '583'},
        {name: 'The Republic of Moldova', code2: 'MD', code3: 'MDA', numeric: '498'},
        {name: 'Monaco', code2: 'MC', code3: 'MCO', numeric: '492'},
        {name: 'Mongolia', code2: 'MN', code3: 'MNG', numeric: '496'},
        {name: 'Montenegro', code2: 'ME', code3: 'MNE', numeric: '499'},
        {name: 'Montserrat', code2: 'MS', code3: 'MSR', numeric: '500'},
        {name: 'Morocco', code2: 'MA', code3: 'MAR', numeric: '504'},
        {name: 'Mozambique', code2: 'MZ', code3: 'MOZ', numeric: '508'},
        {name: 'Myanmar', code2: 'MM', code3: 'MMR', numeric: '104'},
        {name: 'Namibia', code2: 'NA', code3: 'NAM', numeric: '516'},
        {name: 'Nauru', code2: 'NR', code3: 'NRU', numeric: '520'},
        {name: 'Nepal', code2: 'NP', code3: 'NPL', numeric: '524'},
        {name: 'Netherlands', code2: 'NL', code3: 'NLD', numeric: '528'},
        {name: 'New Caledonia', code2: 'NC', code3: 'NCL', numeric: '540'},
        {name: 'New Zealand', code2: 'NZ', code3: 'NZL', numeric: '554'},
        {name: 'Nicaragua', code2: 'NI', code3: 'NIC', numeric: '558'},
        {name: 'Niger', code2: 'NE', code3: 'NER', numeric: '562'},
        {name: 'Nigeria', code2: 'NG', code3: 'NGA', numeric: '566'},
        {name: 'Niue', code2: 'NU', code3: 'NIU', numeric: '570'},
        {name: 'Norfolk Island', code2: 'NF', code3: 'NFK', numeric: '574'},
        {name: 'Republic of Macedonia', code2: 'MK', code3: 'MKD', numeric: '807'},
        {name: 'Northern Mariana Islands', code2: 'MP', code3: 'MNP', numeric: '580'},
        {name: 'Norway', code2: 'NO', code3: 'NOR', numeric: '578'},
        {name: 'Oman', code2: 'OM', code3: 'OMN', numeric: '512'},
        {name: 'Pakistan', code2: 'PK', code3: 'PAK', numeric: '586'},
        {name: 'Palau', code2: 'PW', code3: 'PLW', numeric: '585'},
        {name: 'Palestine', code2: 'PS', code3: 'PSE', numeric: '275'},
        {name: 'Panama', code2: 'PA', code3: 'PAN', numeric: '591'},
        {name: 'Papua New Guinea', code2: 'PG', code3: 'PNG', numeric: '598'},
        {name: 'Paraguay', code2: 'PY', code3: 'PRY', numeric: '600'},
        {name: 'Peru', code2: 'PE', code3: 'PER', numeric: '604'},
        {name: 'Philippines', code2: 'PH', code3: 'PHL', numeric: '608'},
        {name: 'Pitcairn', code2: 'PN', code3: 'PCN', numeric: '612'},
        {name: 'Poland', code2: 'PL', code3: 'POL', numeric: '616'},
        {name: 'Portugal', code2: 'PT', code3: 'PRT', numeric: '620'},
        {name: 'Puerto Rico', code2: 'PR', code3: 'PRI', numeric: '630'},
        {name: 'Qatar', code2: 'QA', code3: 'QAT', numeric: '634'},
        {name: 'Reunion', code2: 'RE', code3: 'REU', numeric: '638'},
        {name: 'Romania', code2: 'RO', code3: 'ROU', numeric: '642'},
        {name: 'Russia', code2: 'RU', code3: 'RUS', numeric: '643'},
        {name: 'Rwanda', code2: 'RW', code3: 'RWA', numeric: '646'},
        {name: 'Saint Barthelemy', code2: 'BL', code3: 'BLM', numeric: '652'},
        {name: 'Saint Helena, Ascension and Tristan da Cunha', code2: 'SH', code3: 'SHN', numeric: '654'},
        {name: 'Saint Kitts and Nevis', code2: 'KN', code3: 'KNA', numeric: '659'},
        {name: 'Saint Lucia', code2: 'LC', code3: 'LCA', numeric: '662'},
        {name: 'Saint Martin', code2: 'MF', code3: 'MAF', numeric: '663'},
        {name: 'Saint Pierre and Miquelon', code2: 'PM', code3: 'SPM', numeric: '666'},
        {name: 'Saint Vincent and the Grenadines', code2: 'VC', code3: 'VCT', numeric: '670'},
        {name: 'Samoa', code2: 'WS', code3: 'WSM', numeric: '882'},
        {name: 'San Marino', code2: 'SM', code3: 'SMR', numeric: '674'},
        {name: 'Sao Tome and Principe', code2: 'ST', code3: 'STP', numeric: '678'},
        {name: 'Saudi Arabia', code2: 'SA', code3: 'SAU', numeric: '682'},
        {name: 'Senegal', code2: 'SN', code3: 'SEN', numeric: '686'},
        {name: 'Serbia', code2: 'RS', code3: 'SRB', numeric: '688'},
        {name: 'Seychelles', code2: 'SC', code3: 'SYC', numeric: '690'},
        {name: 'Sierra Leone', code2: 'SL', code3: 'SLE', numeric: '694'},
        {name: 'Singapore', code2: 'SG', code3: 'SGP', numeric: '702'},
        {name: 'Dutch Saint Maarten', code2: 'SX', code3: 'SXM', numeric: '534'},
        {name: 'Slovakia', code2: 'SK', code3: 'SVK', numeric: '703'},
        {name: 'Slovenia', code2: 'SI', code3: 'SVN', numeric: '705'},
        {name: 'Solomon Islands', code2: 'SB', code3: 'SLB', numeric: '090'},
        {name: 'Somalia', code2: 'SO', code3: 'SOM', numeric: '706'},
        {name: 'South Africa', code2: 'ZA', code3: 'ZAF', numeric: '710'},
        {name: 'South Georgia and the South Sandwich Islands', code2: 'GS', code3: 'SGS', numeric: '239'},
        {name: 'South Sudan', code2: 'SS', code3: 'SSD', numeric: '728'},
        {name: 'Spain', code2: 'ES', code3: 'ESP', numeric: '724'},
        {name: 'Sri Lanka', code2: 'LK', code3: 'LKA', numeric: '144'},
        {name: 'Sudan', code2: 'SD', code3: 'SDN', numeric: '729'},
        {name: 'Suriname', code2: 'SR', code3: 'SUR', numeric: '740'},
        {name: 'Svalbard and Jan Mayen', code2: 'SJ', code3: 'SJM', numeric: '744'},
        {name: 'Sweden', code2: 'SE', code3: 'SWE', numeric: '752'},
        {name: 'Switzerland', code2: 'CH', code3: 'CHE', numeric: '756'},
        {name: 'Syria', code2: 'SY', code3: 'SYR', numeric: '760'},
        {name: 'Taiwan', code2: 'TW', code3: 'TWN', numeric: '158'},
        {name: 'Tajikistan', code2: 'TJ', code3: 'TJK', numeric: '762'},
        {name: 'Tanzania', code2: 'TZ', code3: 'TZA', numeric: '834'},
        {name: 'Thailand', code2: 'TH', code3: 'THA', numeric: '764'},
        {name: 'East Timor / Timor-Leste', code2: 'TL', code3: 'TLS', numeric: '626'},
        {name: 'Togo', code2: 'TG', code3: 'TGO', numeric: '768'},
        {name: 'Tokelau', code2: 'TK', code3: 'TKL', numeric: '772'},
        {name: 'Tonga', code2: 'TO', code3: 'TON', numeric: '776'},
        {name: 'Trinidad and Tobago', code2: 'TT', code3: 'TTO', numeric: '780'},
        {name: 'Tunisia', code2: 'TN', code3: 'TUN', numeric: '788'},
        {name: 'Turkey', code2: 'TR', code3: 'TUR', numeric: '792'},
        {name: 'Turkmenistan', code2: 'TM', code3: 'TKM', numeric: '795'},
        {name: 'Turks and Caicos Islands (the)', code2: 'TC', code3: 'TCA', numeric: '796'},
        {name: 'Tuvalu', code2: 'TV', code3: 'TUV', numeric: '798'},
        {name: 'Uganda', code2: 'UG', code3: 'UGA', numeric: '800'},
        {name: 'Ukraine', code2: 'UA', code3: 'UKR', numeric: '804'},
        {name: 'United Arab Emirates', code2: 'AE', code3: 'ARE', numeric: '784'},
        {name: 'United Kingdom', code2: 'GB', code3: 'GBR', numeric: '826'},
        {name: 'United States Minor Outlying Islands', code2: 'UM', code3: 'UMI', numeric: '581'},
        {name: 'United States', code2: 'US', code3: 'USA', numeric: '840'},
        {name: 'Uruguay', code2: 'UY', code3: 'URY', numeric: '858'},
        {name: 'Uzbekistan', code2: 'UZ', code3: 'UZB', numeric: '860'},
        {name: 'Vanuatu', code2: 'VU', code3: 'VUT', numeric: '548'},
        {name: 'Venezuela', code2: 'VE', code3: 'VEN', numeric: '862'},
        {name: 'Vietnam', code2: 'VN', code3: 'VNM', numeric: '704'},
        {name: 'British Virgin Islands', code2: 'VG', code3: 'VGB', numeric: '092'},
        {name: 'US Virgin Islands', code2: 'VI', code3: 'VIR', numeric: '850'},
        {name: 'Wallis and Futuna', code2: 'WF', code3: 'WLF', numeric: '876'},
        {name: 'Western Sahara', code2: 'EH', code3: 'ESH', numeric: '732'},
        {name: 'Yemen', code2: 'YE', code3: 'YEM', numeric: '887'},
        {name: 'Zambia', code2: 'ZM', code3: 'ZMB', numeric: '894'},
        {name: 'Zimbabwe', code2: 'ZW', code3: 'ZWE', numeric: '716'}        
    ];

    const getCountryData = () => {
        return countryData;    
    };

    const getCountries = () => {
        var countries = countryData.map((item) => {
            return item.name;
        });
        countries.splice(0,0,'');
        return countries;
    };

    const getCountryCodes = () => {
        var codes = countryData.map((item) => {
            return item.code2;
        });
        codes.splice(0,0,'');
        return codes;
    };

    const getStates = () => {
        return [
            {name: 'Alabama', code: 'AL'},
            {name: 'Alaska', code: 'AK'},
            {name: 'Arizona', code: 'AZ'},
            {name: 'Arkansas', code: 'AR'},
            {name: 'American Samoa', code: 'AS'},
            {name: 'California', code: 'CA'},
            {name: 'Colorado', code: 'CO'},
            {name: 'Connecticut', code: 'CT'},
            {name: 'Delaware', code: 'DE'},
            {name: 'District of Columbia', code: 'DC'},
            {name: 'Fed. States of Micronesia', code: 'FM'},
            {name: 'Florida', code: 'FL'},
            {name: 'Georgia', code: 'GA'},
            {name: 'Guam', code: 'GU'},
            {name: 'Hawaii', code: 'HI'},
            {name: 'Idaho', code: 'ID'},
            {name: 'Illinois', code: 'IL'},
            {name: 'Indiana', code: 'IN'},
            {name: 'Iowa', code: 'IA'},
            {name: 'Kansas', code: 'KS'},
            {name: 'Kentucky', code: 'KY'},
            {name: 'Louisiana', code: 'LA'},
            {name: 'Maine', code: 'ME'},
            {name: 'Maryland', code: 'MD'},
            {name: 'Marshall Islands', code: 'MH'},
            {name: 'Massachusetts', code: 'MA'},
            {name: 'Michigan', code: 'MI'},
            {name: 'Minnesota', code: 'MN'},
            {name: 'Mississippi', code: 'MS'},
            {name: 'Missouri', code: 'MO'},
            {name: 'Montana', code: 'MT'},
            {name: 'Nebraska', code: 'NE'},
            {name: 'Nevada', code: 'NV'},
            {name: 'New Hampshire', code: 'NH'},
            {name: 'New Jersey', code: 'NJ'},
            {name: 'New Mexico', code: 'NM'},
            {name: 'New York', code: 'NY'},
            {name: 'North Carolina', code: 'NC'},
            {name: 'North Dakota', code: 'ND'},
            {name: 'Northern Marianas', code: 'MP'},
            {name: 'Ohio', code: 'OH'},
            {name: 'Oklahoma', code: 'OK'},
            {name: 'Oregon', code: 'OR'},
            {name: 'Pennsylvania', code: 'PA'},
            {name: 'Puerto Rico', code: 'PR'},
            {name: 'Rhode Island', code: 'RI'},
            {name: 'South Carolina', code: 'SC'},
            {name: 'South Dakota', code: 'SD'},
            {name: 'Tennessee', code: 'TN'},
            {name: 'Texas', code: 'TX'},
            {name: 'Utah', code: 'UT'},
            {name: 'Vermont', code: 'VT'},
            {name: 'Virginia', code: 'VA'},
            {name: '(U.S.) Virgin Islands', code: 'VI'},
            {name: 'Washington', code: 'WA'},
            {name: 'West Virginia', code: 'WV'},
            {name: 'Wisconsin', code: 'WI'},
            {name: 'Wyoming', code: 'WY'},
            {name: 'Armed Forces, the Americas', code: 'AA'},
            {name: 'Armed Forces, Europe', code: 'AE'},
            {name: 'Armed Forces, Pacific', code: 'AP'},
            {name: 'Alberta', code: 'AB'},
            {name: 'British Columbia', code: 'BC'},
            {name: 'Manitoba', code: 'MB'},
            {name: 'New Brunswick', code: 'NB'},
            {name: 'Newfoundland and Labrador', code: 'NL'},
            {name: 'Northwest Territories', code: 'NT'},
            {name: 'Nova Scotia', code: 'NS'},
            {name: 'Nunavut', code: 'NU'},
            {name: 'Ontario', code: 'ON'},
            {name: 'Prince Edward Island', code: 'PE'},
            {name: 'Québec', code: 'QC'},
            {name: 'Saskatchewan', code: 'SK'},
            {name: 'Yukon Territory', code: 'YT'}
        ]
    }

    const getOrgSubTypes = () =>  {
        return [
            'ORGANIZATION',
            'COMPANY',
            'CRIMINAL',
            'EDUCATIONAL',
            'GOVERNMENT',
            'PERFORMING',
            'NEWS',
            'SOCIALMEDIA',
            'SPORTS',
            'FUND',
            'TRUST'
        ]
    };

    const getGenders = () => {
        return [
            'male',
            'female',
            'transgender male',
            'transgender female',
            'non-binary',
            'unspecified'
        ]
    }

    const getThingSubTypes = () =>  {
        return [
            'THING',
            'CHEMICAL',
            'MEDICAL',
            'FINANCIAL',
            'LEGAL',
            'PRODUCT',
            'TECHNOLOGY'
        ]
    };

    const getProductTypes = () =>  {
        return [
            'AIRCRAFT',
            'AUTOMOBILE',
            'POWERPLANT',
            'SMARTPHONE',
            'MISSILE'
        ]
    };

    const getPhoneTypes = () =>  {
        return [
            'PHONE',
            'FAX',
            'CELL',
            'OTHER'
        ]
    };

    const getOrgEmailTypes = () =>  {
        return [
            'BUSINESS',
            'SUPPORT',
            'CONTACT',
            'OTHER'
        ]
    };

    const getPersonEmailTypes = () =>  {
        return [
            'BUSINESS',
            'PERSONAL',
            'HOME',
            'OTHER'
        ]
    };

    const getEmployerTypes = () => {
        return [
            'Director',
            'Other',
            'Chief Executive Officer',
            'Vice President',
            'Independent Director',
            'Chief Financial Officer',
            'Chairman',
            'President',
            'Secretary',
            'Managing Director',
            'Non-Executive Independent Director',
            'Executive Officer',
            'Senior Vice President',
            'Executive Vice President',
            'Executive Director',
            'Non-Executive Director',
            'Chief Operating Officer',
            'Director of Sales', 
            'Corporate Executive', 
            'General Manager',
            'Vice Chairman',
            'Director of Marketing',
            'Deputy General Manager',
            'Chief Technology Officer',
            'General Counsel',
            'Treasurer',
            'Non-Executive Chairman',
            'Primary Contact',
            'Director of Human Resources',
            'Controller',
            'Finance Director',
            'Chief Accounting Officer',
            'Managing Executive Officer',
            'Co-Founder',
            'Co-Owner',
            'Chief Compliance Officer',
            'Partner',
            'Trustee',
            'Senior Managing Director',
            'Co-Chief Executive Officer',
            'Chief Information Officer',
            'Deputy General Director',
            'Founder',
            'Owner',
            'Chief Administrative Officer',
            'Lead Director',
            'Chief Marketing Officer',
            'General Director',
            'Senior Managing Executive Officer',
            'Director of Investor Relations',
            'Assistant Secretary',
            'Managing Partner',
            'Associate',
            'Deputy Chief Executive Officer',
            'Non-Executive Vice Chairman',
            'Chief Investment Officer',
            'Chief Scientific Officer',
            'Senior Executive Officer',
            'Principal',
            'Chief Risk Officer',
            'Deputy Managing Director',
            'Chief Human Resource Officer',
            'Co-Chairman',
            'Assistant Treasurer',
            'Co-President',
            'General Partner',
            'Venture Partner',
            'Investment Manager',
            'Senior Associate',
            'Operating Partner',
            'Senior Partner',
            'Senior Director',
            'Managing Principal',
            'Executive Partner',
            'Director General',
            'Senior Principal',
            'Contact Person'
        ]
    };

    const getOwnerTypes = () => {
        return [
            'Owner',
            'Co-Owner'
        ]
    };

    const getIdentifierTypes = () => {
        return [
            'CIK',
            'LEI',
            'ISIN',
            'EIN',
            'PERMID',
            'CB_PERMALINK',
            'CB_UUID',
            'BBC',
            'TWITTER',
            'LINKEDIN',
            'WIKIDATA',
            'WIKIPEDIA',
            'FACEBOOK',
            'FREEBASE',
            'GEONAMES',
            'YOUTUBE',
            'QUORA',
            'INSTAGRAM',
            'GOOGLEPLUS',
            'BRITANNICA',
            'URI'
        ]
    }

    return {
        getCountryData,
        getCountries,
        getCountryCodes,
        getStates,
        getOrgSubTypes,
        getGenders,
        getThingSubTypes,
        getProductTypes,
        getPhoneTypes,
        getOrgEmailTypes,
        getPersonEmailTypes,
        getEmployerTypes,
        getOwnerTypes,
        getIdentifierTypes
    }
})();